// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3WCpr","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__SsXGA"};